export default __webpack_public_path__ + "static/media/logo-prisma-small.e17e2b85.svg";